import { render, staticRenderFns } from "./TaskLimitConfigList.vue?vue&type=template&id=3aa453cd"
import script from "./TaskLimitConfigList.vue?vue&type=script&lang=js"
export * from "./TaskLimitConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports